<script>
  /**
   * Standalone is a component that displays a standalone FAB.
   * - button will be shown as standalone if it's set to standalone.
   */
  import { onMount } from "svelte";
  import Container from "../components/Container.svelte";
  import Type from "../components/Type.svelte";
  import { responsive_check } from "../../library/function/browser";
  export let standalones = [];
  let { fab_animation, fab_design } = window.FAB_PLUGIN.options;
</script>

{#each standalones as fab_item, i}
  <Container
    display={responsive_check(fab_item)}
    id="fab-standalone-link-{fab_item.ID}"
    rippleAnimation={false}
    fab={fab_item}
    classNames="fab"
    shape={fab_item.template.shape ? fab_item.template.shape : fab_design.template.shape}
    animation={{
      in: fab_animation.elements.fab,
    }}
    style="width: max-content;"
  >
    <Type {fab_item} classNames="fab-single-collection" />
  </Container>
{/each}
